var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{staticClass:"live-page",class:{
    'is-live': _vm.webcast.status == 'live',
    hasStreams: _vm.hasStreams,
    hasCTA: _vm.pageSettings.callToActionEnabled,
  }},[_c('Navbar'),(_vm.isReady)?_c('Layout',{staticClass:"main-layout"},[_c('Content',{staticClass:"live-content2",staticStyle:{"overflow":"visible"}},[(!_vm.webcast.enableP2P)?_c('LivePlayer',{attrs:{"isSidebarCollapsed":_vm.isCollapsed}}):_vm._e(),_c('question-form',{attrs:{"senderInfo":_vm.senderInfo}})],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }